import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { autoDetectRenderer, extensions, ExtensionType } from '@pixi/core';
import { Container } from '@pixi/display';
var _Application = /*#__PURE__*/function () {
  function _Application(options) {
    var _this = this;
    _classCallCheck(this, _Application);
    this.stage = new Container();
    options = Object.assign({
      forceCanvas: false
    }, options);
    this.renderer = autoDetectRenderer(options);
    _Application._plugins.forEach(function (plugin) {
      plugin.init.call(_this, options);
    });
  }
  _createClass(_Application, [{
    key: "render",
    value: function render() {
      this.renderer.render(this.stage);
    }
  }, {
    key: "view",
    get: function get() {
      return this.renderer.view;
    }
  }, {
    key: "screen",
    get: function get() {
      return this.renderer.screen;
    }
  }, {
    key: "destroy",
    value: function destroy(removeView, stageOptions) {
      var _this2 = this;
      var plugins = _Application._plugins.slice(0);
      plugins.reverse();
      plugins.forEach(function (plugin) {
        plugin.destroy.call(_this2);
      });
      this.stage.destroy(stageOptions);
      this.stage = null;
      this.renderer.destroy(removeView);
      this.renderer = null;
    }
  }]);
  return _Application;
}();
var Application = _Application;
Application._plugins = [];
extensions.handleByList(ExtensionType.Application, Application._plugins);
export { Application };